<template>
  <BaseDialog v-if="type === 'alert' || type === 'confirm'" :open="open">
    <MessageCard
      :type="type"
      :ok="ok"
      :cancel="cancel"
      :message="message"
    />
  </BaseDialog>
  <BaseDialog
    v-if="type === 'linePayAgree'"
    :open="open"
    @click="cancel"
  >
    <!-- ダイアログ外をクリックでキャンセル -->
    <LinePayDialogAgree
      :ok="ok"
      :cancel="cancel"
      @click.stop=""
    />
  </BaseDialog>
  <BaseDialog
    v-if="type === 'linePayResult'"
    :open="open"
  >
    <LinePayDialogResult
      :ok="ok"
      :cancel="cancel"
    />
  </BaseDialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { usePopupDialog } from '@/hooks/use_popup_dialog';

import BaseDialog from './BaseDialog.vue';
import LinePayDialogAgree from './LinePayDialogAgree.vue';
import LinePayDialogResult from './LinePayDialogResult.vue';
import MessageCard from './MessageCard.vue';

export default defineComponent({
  name: 'Dialog',
  components: {
    MessageCard,
    BaseDialog,
    LinePayDialogResult,
    LinePayDialogAgree,
  },
  setup() {
    return usePopupDialog();
  },
});
</script>
